import defaultImg from "@/assets/gallery-river-scene.webp";
import tubing1 from "@/assets/gallery-tubing-scenic.webp";
import tubing2 from "@/assets/gallery-friends-group-tubes.webp";
import tubing3 from "@/assets/gallery-girl-tubing.webp";
import kayak1 from "@/assets/gallery-kayak-scenic.webp";
import kayak2 from "@/assets/gallery-family-kayak.webp";
import kayak3 from "@/assets/kayaking-family.webp";
import glamp1 from "@/assets/gallery-glamping-sunset.webp";
import glamp2 from "@/assets/gallery-glamping-interior.webp";
import glamp3 from "@/assets/glamping-cabin-firepit.webp";
import cabin1 from "@/assets/log-cabin-1.webp";
import cabin2 from "@/assets/log-cabin-3.webp";
import cabin3 from "@/assets/gallery-safari-cabin.webp";
import cabana1 from "@/assets/cabana-15.webp";
import cabana2 from "@/assets/gallery-tiki-cabana.webp";
import cabana3 from "@/assets/cabana-26.webp";
// Covered Picnic Tables
import picnic1 from "@/assets/picnic-table-20.webp";
import picnic2 from "@/assets/picnic-table-11.webp";
import picnic3 from "@/assets/picnic-table-card.webp";
import picnic4 from "@/assets/gallery-picnic-table-river.webp";
import picnic5 from "@/assets/picnic-table-40.webp";
import picnic6 from "@/assets/picnic-table-22.webp";
// Additional thumbnails (6 per category)
import tubing4 from "@/assets/gallery-tubing-picnic.webp";
import tubing5 from "@/assets/gallery-couple-tubing.webp";
import tubing6 from "@/assets/family-tubing.webp";
import kayak4 from "@/assets/about-hero-kayak.webp";
import kayak5 from "@/assets/gallery-kids-playing-river.webp";
import kayak6 from "@/assets/gallery-mom-child-river.webp";
import glamp4 from "@/assets/gallery-glamping-dusk.webp";
import glamp5 from "@/assets/gallery-glamping-night.webp";
import glamp6 from "@/assets/gallery-glamping-row-night.webp";
import cabin4 from "@/assets/log-cabin-2.webp";
import cabin5 from "@/assets/log-cabin-4.webp";
import cabin6 from "@/assets/log-cabin-5.webp";
import cabana4 from "@/assets/cabana-13.webp";
import cabana5 from "@/assets/cabana-20.webp";
import cabana6 from "@/assets/cabana-22.webp";

export interface PopupImage {
  id: string;
  src: string;
  alt: string;
}

export interface PopupImageGroup {
  category: string;
  items: PopupImage[];
}

export const POPUP_IMAGE_GROUPS: PopupImageGroup[] = [
  {
    category: "Tubing",
    items: [
      { id: "gallery-tubing-scenic", src: tubing1, alt: "Scenic river tubing" },
      { id: "gallery-friends-group-tubes", src: tubing2, alt: "Friends tubing together" },
      { id: "gallery-girl-tubing", src: tubing3, alt: "Girl floating on a tube" },
      { id: "gallery-tubing-picnic", src: tubing4, alt: "Tubing near riverside picnic" },
      { id: "gallery-couple-tubing", src: tubing5, alt: "Couple tubing on the river" },
      { id: "family-tubing", src: tubing6, alt: "Family tubing together" },
    ],
  },
  {
    category: "Kayaking",
    items: [
      { id: "gallery-kayak-scenic", src: kayak1, alt: "Scenic kayaking on the river" },
      { id: "gallery-family-kayak", src: kayak2, alt: "Family kayaking together" },
      { id: "kayaking-family", src: kayak3, alt: "Family enjoying kayaks" },
      { id: "about-hero-kayak", src: kayak4, alt: "Kayaker on the Blue River" },
      { id: "gallery-kids-playing-river", src: kayak5, alt: "Kids playing in the river" },
      { id: "gallery-mom-child-river", src: kayak6, alt: "Mom and child on the river" },
    ],
  },
  {
    category: "Glamping",
    items: [
      { id: "gallery-glamping-sunset", src: glamp1, alt: "Glamping cabin at sunset" },
      { id: "gallery-glamping-interior", src: glamp2, alt: "Glamping cabin interior" },
      { id: "glamping-cabin-firepit", src: glamp3, alt: "Glamping cabin with firepit" },
      { id: "gallery-glamping-dusk", src: glamp4, alt: "Glamping cabin at dusk" },
      { id: "gallery-glamping-night", src: glamp5, alt: "Glamping cabin at night" },
      { id: "gallery-glamping-row-night", src: glamp6, alt: "Row of glamping cabins at night" },
    ],
  },
  {
    category: "Cabins",
    items: [
      { id: "log-cabin-1", src: cabin1, alt: "Log cabin exterior" },
      { id: "log-cabin-3", src: cabin2, alt: "Log cabin with deck" },
      { id: "gallery-safari-cabin", src: cabin3, alt: "Safari-style cabin" },
      { id: "log-cabin-2", src: cabin4, alt: "Log cabin riverside view" },
      { id: "log-cabin-4", src: cabin5, alt: "Log cabin with porch" },
      { id: "log-cabin-5", src: cabin6, alt: "Log cabin interior" },
    ],
  },
  {
    category: "Cabanas",
    items: [
      { id: "cabana-15", src: cabana1, alt: "Riverside cabana" },
      { id: "gallery-tiki-cabana", src: cabana2, alt: "Tiki-style cabana" },
      { id: "cabana-26", src: cabana3, alt: "Cabana by the water" },
      { id: "cabana-13", src: cabana4, alt: "Cabana with riverside seating" },
      { id: "cabana-20", src: cabana5, alt: "Two-story cabana" },
      { id: "cabana-22", src: cabana6, alt: "Cabana shaded by trees" },
    ],
  },
  {
    category: "Covered Picnic Tables",
    items: [
      { id: "picnic-table-20", src: picnic1, alt: "Covered picnic table on the sand by the Blue River" },
      { id: "picnic-table-11", src: picnic2, alt: "Covered picnic table with hammock and grill by the river" },
      { id: "picnic-table-card", src: picnic3, alt: "Family gathered under a covered picnic table at the water's edge" },
      { id: "gallery-picnic-table-river", src: picnic4, alt: "Covered picnic table with tubers floating past" },
      { id: "picnic-table-40", src: picnic5, alt: "Wide view of covered picnic tables along the riverbank" },
      { id: "picnic-table-22", src: picnic6, alt: "Row of covered picnic tables along the river" },
    ],
  },
];

export const DEFAULT_POPUP_IMAGE_ID = "gallery-river-scene";

const INDEX: Record<string, PopupImage> = {
  [DEFAULT_POPUP_IMAGE_ID]: {
    id: DEFAULT_POPUP_IMAGE_ID,
    src: defaultImg,
    alt: "Son's Blue River Camp riverfront",
  },
};
for (const g of POPUP_IMAGE_GROUPS) for (const it of g.items) INDEX[it.id] = it;

export function getPopupImage(id: string): PopupImage {
  return INDEX[id] ?? INDEX[DEFAULT_POPUP_IMAGE_ID];
}